export default {
  STOCK: '证券',
  FUTURES: '期货',
  FOREX: '外汇',
  IB: 'EddidPro',
  FUND: '基金',
  mt5: '(MT5)',
  mf: '(Eddid FX Pro)',
  ACCOUNT: '账户 | ',
  MF: 'FX Pro',
  PM: '现货黄金',
  fundCash: '基金',
  stockOptionsCash: '香港股票期权账户(现金)',
  securitiesCash: '香港及环球证券账户(现金)',
  securitiesMargin: '香港及环球证券账户(保证金)',
  securitiesDayTradeMargin: '香港证券即日买卖账户(保证金)',
  futuresMargin: '香港及环球期货账户(保证金)',
  futuresDayTradeMargin: '香港期货即日买卖账户(保证金)',
  interactiveBrokerIntegratedMargin: '盈透证券综合户口(保证金)',
  please_select: '请选择',
  please_select_currency: '请选择币种',
  submit: '提交',
  please_input: '请输入',
  contiune: '继续',
  ok: '确定',
  edit: '编辑',
  cancel: '取消',
  yes: '是',
  no: '否',
  resign: '重签',
  cancelLogout: '已取消退出登录',
  noCancel: '该订单不能撤销',
  codeFail: '验证码不正确',
  changeSuccess: '修改成功！',
  changeFail: '修改失败',
  inputNewPassword: '请输入新密码',
  inputNewPasswordAgain: '请再次输入新密码',
  notIdentical: '两次密码不一致',
  uploadFail: '网络错误,上传失败！',
  imageRepeat: '不能重复上传！',
  fail: '失败',
  loadingFailTip: '加载失败',
  exhangeTo: '兑换至',
  usd: '美元',
  hkd: '港币',
  cny: '人民币',
  cencel_dialog: {
    tip: {
      withdrawal: '确认要撤销本次取款吗？',
      transfer: '确认要撤销本次转账吗？'
    },
    cancel: {
      withdrawal: '阁下已成功撤回本次取款。',
      transfer: '阁下已成功撤回本次内部转账。'
    },
    check_info: '确认信息',
    reminder: '请确认信息并提交信息'
  },
  preview_dialog: {
    tip: {
      deposit: '请核对您的存款凭证切勿重复上传，如有疑问请与我们联系',
      withdrawal: '提款申请期间如您在交易，可能导致提款失败，如有问题请与我们联系。',
      transfer: '转账申请期间如您在交易，可能导致转账失败，如有问题请与我们联系',
      attention: '注意事项：'
    },
    tip1: '<div style="margin-bottom: 4px">1.本公司收取银行转账手续费每笔350港币</div>' +
      '<div style="margin-bottom: 4px">2.银行可能收取行政费用，具体请向收款银行查询</div>' +
      '3.如汇款往内地，可能会有内地银行拒收退回情况。若发生退款，已收取手续费不做退回',
    withdrawalTip: '<div style="margin-bottom: 4px">1.由于阁下兑换并卖出所赠送的股票未符合是次活动要求的交易任务，根据活动规则，艾德证券期货将在阁下是次提款时收取27美元的首年账户管理费</div>' +
      '<div style="margin-bottom: 4px">2.提款申请期间如您在交易，可能导致提款失败，如有问题请与我们联系。',
    withdrawalfinanceTip: '<div style="margin-bottom: 4px">1.阁下已提交「一手融」 新股认购申请，且提款后证券账户总资产低于 HKD5,000.00，根据公司政策，阁下是次提款需缴付总额外手续费{}或等值货币。(以每只「一手融」认购申请缴付HKD500.00额外手续费计算)</div>' +
      '<div style="margin-bottom: 4px">2.提款申请期间如您在交易，可能导致提款失败，如有问题请与我们联系。</div>',
    withdrawalallTip: `<div style="margin-bottom: 4px">1.由于阁下兑换并卖出所赠送的股票未符合是次活动要求的交易任务，根据活动规则，艾德证券期货将在阁下是次提款时收取27美元的首年账户管理费</div>
    <div style="margin-bottom: 4px">2.阁下已提交「一手融」 新股认购申请，且提款后证券账户总资产低于 HKD5,000.00，根据公司政策，阁下是次提款需缴付总额外手续费{}或等值货币。(以每只「一手融」认购申请缴付HKD500.00额外手续费计算)</div>
    <div style="margin-bottom: 4px">3.提款申请期间如您在交易，可能导致提款失败，如有问题请与我们联系。</div>`,
    overseaTip: '<div style="margin-bottom: 4px">1.由于阁下兑换并卖出所赠送的股票未符合是次活动要求的交易任务，根据活动规则，艾德证券期货将在阁下是次提款时收取27美元的首年账户管理费</div>' +
      '<div style="margin-bottom: 4px">2.取款申请期间如您在交易，可能导致转账失败，如有问题请与我们联系</div>' +
      '<div style="margin-bottom: 4px">3.本公司收取银行转账手续费每笔350港币</div>' +
      '<div style="margin-bottom: 4px">4.银行可能收取行政费用，具体请向收款银行查询</div>' +
      '5.如汇款往内地，可能会有内地银行拒收退回情况。若发生退款，已收取手续费不做退回',
    overseafinanceTip: '<div style="margin-bottom: 4px">1.阁下已提交「一手融」 新股认购申请，且提款后证券账户总资产低于 HKD5,000.00，根据公司政策，阁下是次提款需缴付总额外手续费{}或等值货币。(以每只「一手融」认购申请缴付HKD500.00额外手续费计算)</div>' +
      '<div style="margin-bottom: 4px">2.取款申请期间如您在交易，可能导致转账失败，如有问题请与我们联系</div>' +
      '<div style="margin-bottom: 4px">3.本公司收取银行转账手续费每笔350港币</div>' +
      '<div style="margin-bottom: 4px">4.银行可能收取行政费用，具体请向收款银行查询</div>' +
      '5.如汇款往内地，可能会有内地银行拒收退回情况。若发生退款，已收取手续费不做退回',
    overseaallTip: '<div style="margin-bottom: 4px">1.由于阁下兑换并卖出所赠送的股票未符合是次活动要求的交易任务，根据活动规则，艾德证券期货将在阁下是次提款时收取27美元的首年账户管理费</div>' +
      '<div style="margin-bottom: 4px">2.阁下已提交「一手融」 新股认购申请，且提款后证券账户总资产低于 HKD5,000.00，根据公司政策，阁下是次提款需缴付总额外手续费{}或等值货币。(以每只「一手融」认购申请缴付HKD500.00额外手续费计算)</div>' +
      '<div style="margin-bottom: 4px">3.取款申请期间如您在交易，可能导致转账失败，如有问题请与我们联系</div>' +
      '<div style="margin-bottom: 4px">4.本公司收取银行转账手续费每笔350港币</div>' +
      '<div style="margin-bottom: 4px">5.银行可能收取行政费用，具体请向收款银行查询</div>' +
      '6.如汇款往内地，可能会有内地银行拒收退回情况。若发生退款，已收取手续费不做退回',
    transferfinanceTip: '<div style="margin-bottom: 4px">1.阁下已提交「一手融」 新股认购申请，且转账后证券账户总资产低于 HKD5,000.00，根据公司政策，阁下是次转账需缴付总额外手续费{}或等值货币。(以每只「一手融」认购申请缴付HKD500.00额外手续费计算)</div>' +
      '2.转账申请期间如您在交易，可能导致转账失败，如有问题请与我们联系',
    transferTip: '<div style="margin-bottom: 4px">转账申请期间如您在交易，可能导致转账失败，如有问题请与我们联系</div>',
    check_info: '核对信息',
    reminder: '请确认信息并提交信息',
    // 转账
    outAccount: '扣款账号',
    inAccount: '收款账号',
    outAmount: '转账金额',
    // 出金
    account_number: '账号',
    bank_card_number: '银行卡号',
    bank_card_name: '银行名称',
    withdrawal_amount: '取款金额',

    serviceCharge: '服务费',
    accountFee: '账户管理费',
    actualAmount: '实际取款金额',
    withdrawal_name: '英文名/中文拼音',
    withdrawal_bank_name: '银行名称',
    withdrawal_bank_card: '银行卡号',
    withdrawal_swift_no: 'SWIFT Code（银行国际代码)',
    otherBankName: '其他银行名称',
    otherBankCard: '其他银行账号',
    financeFee: '一手融手续费',
    actualtransferAmount: '实际转账金额',
    // 入金
    account_info: '账号',
    bank_info: '银行卡号',
    eddid_bank: '艾德银行卡号',
    depositAmount: '存款金额',
    number: '客户账号',
    customer: '客户姓名',
    amount: '预存款金额',
    // 换汇
    tradeAccount: '交易账号',
    exchangeCurrency: '换汇货币',
    exchangeRate: '汇率',
    swapAmount: '换汇金额'
  },
  accountOpen: '子账户开户申请',
  accountClose: '子账户注销申请',
  three_list: {
    bankName: '银行名称',
    currency: '银行货币',
    createdTime: '提交时间',
    bankNum: '银行账号',
    transfer: '转账',
    withdrawal: '取款',
    deposit: '存款',
    cenceledBtn: '撤销',
    fromAccount: '扣款账号',
    toAccount: '收款账号',
    outAmount: '转账金额',
    accountNo: '账号',
    bankCard: '银行卡号',
    withdrawalAmout: '取款金额',
    depositAmout: '存款数额',
    remark: '备注',
    amout: '数额',
    fullName: '客户姓名',
    applicationAmount: '申请金额',
    completed: '完成',
    processing: '已提交',
    failure: '失败',
    submitted: '已提交',
    withdrawalcompleted: '已处理',
    checking: '已提交',
    verified: '已提交',
    latest_records: '最新记录',
    view_more: '查看更多 >',
    order_No: '订单编号：',
    enName: '英文名/中文拼音',
    swiftNo: 'SWIFT代码',
    updatedTime: '更新时间',
    exchangeRate: '汇率',
    toCurrency: '兑换币种',
    swapAmount: '换汇金额',
    applyService: '申请服务',
    fee: '费用明细',
    businessId: '备注',
    realAmount: '到账金额',
    exchangeAmount: '换汇后入账金额',
    fundBankType: '办理业务',
    tradeAccountType: '交易账户',
    depositWay: '入金方式',
    withdrawoutWay: '出金方式',
    accountName: '账户名称',
    applyTime: '申请时间',
    realExchangeRate: '实际汇率',
    exchangeAmountapply: '申请换汇金额',
    lockWay: '锁定方向',
    exchangeRealAmount: '实际换汇金额'

  },
  upload: {
    uploadFail: '网络异常，上传图片失败',
    limitNumber: `只能上传{0}张图片`,
    limitSize: '图片大小超出{0}M，上传失败'
  },
  eddidTips: '如您的资料与开户时所提交的资料不相同，请致电 +852 2655 0338 / 400 120 0068（中国内地免费热线） 或发送邮件至 cs@eddidsec.com与客服人员联系, 谢谢。',
  applyText: '申请',
  nodata: '暂无数据',
  uploadImg: '请上传图片',
  yztransfer: '银证转账',
  BANK_SECURITIES_ADD: '绑定银证转账',
  BANK_SECURITIES_UNBIND: '解绑银证转账',
  yzAccount: '银证转账账户',
  commonAccount: '普通账户',
  iknow: '我知道了',
  knowIt: '知道了',
  gotIt: '知道了',
  statementArr: [
    {
      text: '《个人资料收集声明》',
      link: 'https://download.eddidapp.com/pdf/SC/personalStatement.pdf'
    },
    {
      text: '《共同汇报标准声明》',
      link: 'https://download.eddidapp.com/pdf/SC/statementCommonReportingStandards.pdf'
    },
    {
      text: '《客户声明》',
      link: 'https://download.eddidapp.com/pdf/SC/customerStatement.pdf'
    },
    {
      text: '《私隐政策声明》',
      link: 'https://download.eddidapp.com/pdf/SC/privacy-policy-statement.pdf'
    },
    {
      text: '《风险披露声明》',
      link: 'https://download.eddidapp.com/pdf/SC/Risk-Disclosure-Statement.pdf'
    },
    {
      text: '《业务条款及细则》',
      link: 'https://download.eddidapp.com/pdf/SC/Business-Terms-and-Conditions.pdf'
    },
    {
      text: '《客户申请数字证书相关条款》',
      link: 'https://download.eddidapp.com/pdf/SC/customersTerms.pdf'
    }
  ],
  otherText: '其他',
  spInfo: '暂不支持Sharp Point交易账户进行此操作',
  riskTolerance: '风险承受能力',
  high: '高',
  medium: '中',
  low: '低',
  'invest': '投资目的',
  'speculation': '投机',
  'hedge': '对冲',
  'assetAppreciation': '资产增值',
  'interestIncome': '利息/股息收入',
  'targetError': '请选择投资目的',
  'futuredErrorInfo': '开立期货账户时投资目的不能仅为利息/股息收入',
  'riskError': '风险承受能力为中/低，不适合买卖结构性产品及衍生产品。',
  dormant: '不活跃',
  dormantTip: '阁下可透过流动应用程序申请重启账户。如对上述事宜有任何查询，欢迎致电+852 2655 0338 / 400 120 0068（中国内地免费热线） 或 电邮至cs@eddidsec.com 与客户服务部联络。',
  dormantDetailTip: '阁下之交易账户目前正处于不活跃状态，现时之资金与证券提取功能将受到限制。阁下可透过流动应用程序申请重启账户。如对上述事宜有任何查询，欢迎致电+852 2655 0338 / 400 120 0068（中国内地免费热线）或电邮至cs@eddidsec.com与客户服务部联络。',
  reactivate: '重启',
  back: '返回',
  sureBtn: '确认',
  blockedTip: '为配合最新监管要求，本公司已暂停阁下所在地区之存款服务。如有查询，请致电 +852 2655 0338 / 400 120 0068（中国内地免费热线）联络我们。'
}
